import React, { useMemo, useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import PrintIcon from "@mui/icons-material/Print";
import { Edit } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import { getCompleteBillings, billUpdate } from "../../../Services/Services";
import InfiniteScroll from "react-infinite-scroll-component";
import Tooltip from "@mui/material/Tooltip";



const BillSummaryTable = () => {
  const [billData, setBillData] = useState([]);
  const [filters, setFilters] = useState({
    branch: "",
    billId: null,
    freightId: null,
    party: "",
  });



  const [billings, setBillings] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchBillings = async (pageNo, activeFilters = filters) => {
    const data = await getCompleteBillings(pageNo, activeFilters);
    if (pageNo === 1) {
      setBillings(data.results || []); // reset for fresh search
    } else if (data?.results?.length) {
      setBillings((prev) => [...prev, ...data.results]);
    }
    setHasMore(Boolean(data?.next));
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1); // ✅ sync page state
      fetchBillings(1, filters); // ✅ sync data state
    }, 500);
    return () => clearTimeout(handler);
  }, [filters]);


  const fetchMoreData = () => {
    setPage((prev) => {
      const nextPage = prev + 1;
      fetchBillings(nextPage);
      return nextPage;
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };


  const [editableRow, setEditableRow] = useState(null); // row.billing_id or index
  const [editData, setEditData] = useState({
    follow_date: "",
    remarks: "",
    payment_remarks: "",
  });


  const filteredData = useMemo(() => {
    return billData.filter((row) => {
      const matchBranch = filters.branch
        ? row.branch_name.toLowerCase().includes(filters.branch.toLowerCase())
        : true;
      const matchBillingId = filters.billId
        ? row.billing_id?.toString().includes(filters.billId.trim())
        : true;
      const matchFreightId = filters.freightId
        ? row.freights?.some((freight) =>
          freight.freight_id?.toString().includes(filters.freightId.trim())
        )
        : true;
      const matchParty = filters.party
        ? row.party_name.toLowerCase().includes(filters.party.toLowerCase())
        : true;

      return matchBranch && matchBillingId && matchFreightId && matchParty;
    });
  }, [filters, billData]);

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
  const getInitials = (str) => {
    return str
      .split(" ")
      .filter((word) => word)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  // Need To Add This For Print Function

  const handlePrintClicksiltara = (row) => {
    const freightRows =
      row.freights
        ?.map(
          (item, index) => `
    <tr>
      <td>${index + 1}</td>
          <td>${formatOnlyDate(item.loading_date) || ""}</td>
      <td>${item.truck_no || ""}</td>
           <td>${item.do_no || ""}</td>
      <td>${item.loading_wt || ""}</td>
      <td>${item.received_wt || ""}</td>
      <td>${item.shortage_wt || 0}</td>
      <td>${item.freight_rate || ""}</td>
      <td>${item.total_advance || ""}</td>
    
      <td></td>
    </tr>
  `
        )
        .join("") || "";
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
<html>
<head>
    <title> ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            margin: 20px;
        }
        .header {
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 10px;
        }
        .header-top {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
        }
        .title-container {
            background-color: black;
            width: 100%;
            padding: 5px 0;
        }
        .title {
            font-weight: bold;
            font-size: 36px;
            color: white;
        }
        .subtitle {
            font-weight: bold;
            margin: 2px 0;
        }
        .ref-date {
            display: flex;
            justify-content: space-between;
            margin: 5px 0 5px 0;
        }
        .recipient {
            text-align: start;
            margin-bottom: 20px;
        }
        .account {
            text-align: center;
            font-weight: bold;
            margin-bottom: 10px;
            line-height: 0.5;
        }
        table {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto; /* allows flexibility */
        font-size: 13px;
        line-height: 1.3;
        border: 1px solid black;
    }

    th, td {
        border: 1px solid black;
        text-align: center;
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    th {
        background-color: #f0f0f0;
        font-weight: bold;
    }

    </style>
</head>
<body>

    <div class="header">
        <div class="header-top">
            <div>Pan No - BKDPD9609Q</div>
            <div>Mo. No - 8727048717</div>
        </div>
        <div class="title-container">
            <div class="title">MAA BANJARI ROADWAYS</div>
        </div>
        <div class="subtitle">SILTARA, RAIPUR (C.G.)</div>
    </div>

    <div class="ref-date">
        <div>Ref. No. :  ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</div>
        <div>Date :  ${formatOnlyDate(row.created_at)}</div>
    </div>

    <div class="account">
        <p>ACCOUNT DETAILS</p>
        <p>NAME : MAA BANJARI ROADWAYS</p>
        <p>A/C NO : 1216102000004497</p>
        <p>IFSC CODE : IBKL0001216</p>
    </div>

    <div class="recipient">
        <p>TO,<br>${row.party_name}<br>${row.address}</p>
    </div>

    <table>
        <tr>
        <th>Sr. No</th>
           <th>Date</th>
        <th>Truck No.</th>
        <th>Do No</th>
        <th>Load Wt</th>
        <th>Rec Wt</th>
        <th>Short Wt</th>
        <th>Rate</th>
        <th>Total Adv.</th>
        
        <th>Remark</th>
      </tr>
        ${freightRows}
    </table>
     <footer style="position: fixed; bottom: 0; left: 0; width: 100%; text-align: center; font-size: 12px; color: #555;">
      Powered by : YASHVITECH IT SOLUTION PVT. LTD. , 8223079476
    </footer>
     <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() {
        window.close();
      };
    };
  </script>

</body>
</html>


    `);

    printWindow.document.close();
  };
  const handlePrintClickBilaspur = (row) => {
    const freightRows =
      row.freights
        ?.map(
          (item, index) => `
    <tr>
      <td>${index + 1}</td>
          <td>${formatOnlyDate(item.loading_date) || ""}</td>
      <td>${item.truck_no || ""}</td>
           <td>${item.do_no || ""}</td>
      <td>${item.loading_wt || ""}</td>
      <td>${item.received_wt || ""}</td>
      <td>${item.shortage_wt || 0}</td>
      <td>${item.freight_rate || ""}</td>
      <td>${item.total_advance || ""}</td>
    
      <td></td>
    </tr>
  `
        )
        .join("") || "";
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
     <html>
<head>
  <title>
    ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }${row.billing_id}${getInitials(row.party_name)}
    </title>
  <style>
    body {
      font-family: Arial, sans-serif;
      padding: 20px;
      background-color: #fff;
      background-image: url(https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/bg.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .center {
      text-align: center;
    }
    .title {
      font-size: 32px;
      font-weight: bold;
      color: #fff;
      border: 2px solid white;
      display: inline-block;
      padding: 8px 16px;
      border-radius: 6px;
      margin-bottom: 5px;
    }
    .subtitle {
      font-size: 13px;
      color: #fff;
    }
    .info-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      font-size: 12px;
    }
    .info-table td {
      border: 1px solid black;
      padding: 4px;
      vertical-align: top;
    }
    th{
         background-color: rgba(211, 211, 211, 0.42); /* light grey */
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
    .small-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      font-size: 12px;
    }
    .small-table th, .small-table td {
      border: 1px solid black;
      padding: 4px;
      text-align: center;
    }
    .small-table thead {
      background-color: #f0f0f0;
      font-weight: bold;
    }
    #footer-print {
      position: fixed;
            bottom: 25px;
            width: 100%;
            text-align: center;
    }
    #hrtag {
      position: fixed;
            bottom: 0px;
            width: 100%;
    }
               .account-info {
  page-break-inside: avoid;
  break-inside: avoid;
  padding: 10px;
  font-size: 16px;
  text-align: start;
  margin-top: 20px;
  border-top: 1px dashed #ccc;
}

    .contact {
      display: flex;
      justify-content: center;
      gap: 20px;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 8px;
      font-size: 14px;
    }
    .contact-item {
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .icon {
      font-size: 16px;
      color: #d4af37;
    }
    .whatsapp-icon {
      color: #25D366;
    }
      footer {
            position: fixed;
            bottom: 0px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
    .account-info h3{
    font-size: 18px;
      margin-bottom: 10px;
    }
      .account-info p{
    font-size: 18px;
      margin-bottom: 10px;
      font-weight: bold;
      font-size: 16px;
    }
    .account-info{
     line-height: 0.4;
    }
    
  </style>
</head>
<body>

  <div class="center">
    <div class="title">JAI HANUMAN TRANSPORT</div>
  
  </div>

  <div style="font-size: 14px; color: #fff; margin-top: 5px; display: flex; justify-content: space-between; padding: 0 40px;">
  <div style="text-align: left;">
    <div>Transport Nagar, Raipur (C.G.)</div>
    <div>Contact: 9685190720</div>
    <div>PAN: BJVPS6722C</div>
    <div style="margin-top: 5px;" >Ref No: ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }/${row.billing_id}/${getInitials(row.party_name)}</div>
  </div>
  <div style="text-align: right;">
    <div>Date: ${formatOnlyDate(row.created_at)}</div>
  </div>
  </div>
<div style="line-height: 1; margin-top: 20px; padding: 10px;">
  <p style="margin: 0;"><strong>To:</strong></p>
  <p style="margin: 0;"><strong>${row.party_name}</strong></p>
  <p style="margin: 0;">${row.address}</p>
</div>

  <table class="small-table">
    <thead>
      <tr>
        <th>Sr. No</th>
           <th>Date</th>
        <th>Truck No.</th>
        <th>Do No</th>
        <th>Load Wt</th>
        <th>Rec Wt</th>
        <th>Short Wt</th>
        <th>Rate</th>
        <th>Total Adv.</th>
        
        <th>Remark</th>
      </tr>
    </thead>
    <tbody>
   ${freightRows}
    </tbody>
  </table>
 <div class="account-info">
      <h3><b>Account Details :-</b></h3>
      <p><b>NAME : JAI HANUMAN TRANSPORT</b></p>
      <p><b>A/C NO : 181705500997</b></p>
      <p><b>IFSC CODE : ICIC0001817</b></p>
      <p><b>BANK : ICICI BANK (RAIPUR)</b></p>
 
           </div>
        
  
  <hr style="border: none; border-top: 1px solid #aaa; margin: 20px 0;" id="hrtag" />
<footer>Powered by : YASHVITECH IT SOLUTION PVT. LTD. , 8223079476</footer>
  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() {
        window.close();
      };
    };
  </script>

</body>
</html>

    `);

    printWindow.document.close();
  };

  const handlePrintClickRaipur = (row) => {
    const firstPageLimit = 25;
    const otherPagesLimit = 35;
    const freights = row.freights;

    const chunkedRows = [];
    let i = 0;

    // First page: 25 items
    if (freights.length > 0) {
      chunkedRows.push(freights.slice(0, firstPageLimit));
      i = firstPageLimit;
    }

    // Subsequent pages: 35 items each
    while (i < freights.length) {
      chunkedRows.push(freights.slice(i, i + otherPagesLimit));
      i += otherPagesLimit;
    }

    const generateTablePages = () =>
      chunkedRows
        .map((chunk, pageIndex) => {
          const rows = chunk
            .map(
              (item, index) => `
            <tr>
              <td>${pageIndex === 0
                  ? index + 1
                  : firstPageLimit +
                  (pageIndex - 1) * otherPagesLimit +
                  index +
                  1
                }</td>
              <td>${formatOnlyDate(item.loading_date) || ""}</td>
              <td>${item.truck_no || ""}</td>
              <td>${item.do_no || ""}</td>
              <td>${item.loading_wt || ""}</td>
              <td>${item.received_wt || ""}</td>
              <td>${item.shortage_wt || 0}</td>
              <td>${item.freight_rate || ""}</td>
              <td>${item.total_advance || ""}</td>
              <td></td>
            </tr>`
            )
            .join("");

          return `
          <div class="page-section">
            ${pageIndex === 0
              ? `
              <div class="top-banner">
                <div class="banner-text">
                  <h1>S. R. ENTERPRISES</h1>
                  <p>Transport Contractor & Commission Agent</p>
                  <p><strong>PAN: LZQPS9703J</strong></p>
                  <p>Ashutosh Ku. Singh</p>
                </div>
              </div>
              <div class="ref-account-row">
                <div class="recipient-info">
                  <p><strong>Ref No:</strong>  ${row.branch_name === "RAIPUR"
                ? "SRE"
                : row.branch_name === "BILASPUR"
                  ? "JHT"
                  : "MBR"
              }/${row.billing_id}/${getInitials(row.party_name)}</p>
                  <p><strong>Date:</strong> ${formatOnlyDate(
                row.created_at
              )}</p>
                  <p><strong>To:</strong></p>
                  <p>${row.party_name}</p>
                  <p>${row.address}</p>
                </div>
                <div class="account-info">
                  <h3>Account Details :-</h3>
                  <p><strong>NAME: S.R. ENTERPRISES</strong></p>
                  <p><strong>A/C NO: 50200079484752</strong></p>
                  <p><strong>IFSC CODE: HDFC0006110</strong></p>
                  <p><strong>BANK: HDFC BANK (RAIPUR)</strong></p>
                </div>
              </div>
            `
              : ""
            }
            <table>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Truck No.</th>
                  <th>Do No</th>
                  <th>Load Wt</th>
                  <th>Rec Wt</th>
                  <th>Short Wt</th>
                  <th>Rate</th>
                  <th>Total Adv.</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
            ${pageIndex === chunkedRows.length - 1
              ? `
              <div class="footer-fixed">
                <p class="address">Near RTO Office, Transport Nagar, Raipur (C.G.) 493221</p>
                <div class="contact-row">
                  <span><img src="https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/telephone.png" /> 8602856129</span>
                  <span><img src="https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/phone-call.png" /> 8602856129</span>
                  <span><img src="https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/email.png" /> singhashu1555@gmail.com</span>
                </div>
                <div>Powered by - YASHVITECH IT SOLUTION PVT. LTD. , 8223079476</div>
              </div>`
              : ""
            }
          </div>`;
        })
        .join("");

    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
  <title> ${row.branch_name === "RAIPUR"
        ? "SRE"
        : row.branch_name === "BILASPUR"
          ? "JHT"
          : "MBR"
      }${row.billing_id}${getInitials(row.party_name)} </title>
  <style>
    * { box-sizing: border-box; }
    body { margin: 0; font-family: Arial, sans-serif; }
    .top-banner {
      height: 180px;
      background: url('https://vehiclemanagement.s3.ap-south-1.amazonaws.com/sr/2.png') no-repeat center top;
      background-size: contain;
      position: relative;
    }
    .banner-text {
      position: absolute; top: -20px; left: 98px; color: white;
    }
    .banner-text h1 { font-size: 2.3rem; margin-bottom: 0.2rem; line-height: 1.2; }
    .banner-text p { margin: 0.1rem 0; line-height: 1.2; }
    .ref-account-row { display: flex; justify-content: space-between; margin: 10px 20px; }
    .recipient-info p, .account-info p { margin: 0; font-size: 13px; }
    .account-info h3 { margin: 0 0 4px 0; font-size: 14px; text-decoration: underline; }
    table { width: 100%; border-collapse: collapse; font-size: 13px; margin-top: 10px; }
    th, td { border: 1px solid #000; padding: 4px; text-align: center; }
    thead { background-color: #f3f3f3; display: table-header-group; }
    tr { page-break-inside: avoid; }
    .page-section { position: relative; min-height: 100vh; padding: 20px; box-sizing: border-box; page-break-after: always; }
    .page-section:last-child { page-break-after: auto; }
    .footer-fixed {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      padding: 10px 20px;
      text-align: center;
      font-weight: bold;
      color: #333;
      font-size: 13px;
      border-top: 1px solid #ddd;
    }
    .footer-fixed .address { font-size: 13px; }
    .contact-row { display: flex; justify-content: center; gap: 20px; flex-wrap: wrap; margin: 5px 0; }
    .contact-row span { font-size: 13px; display: flex; align-items: center; }
    .contact-row img { width: 16px; height: 16px; margin-right: 5px; }
  </style>
</head>
<body>
  ${generateTablePages()}
  <script>
    window.onload = function () {
      window.print();
      window.onafterprint = function () {
        window.close();
      };
    };
  </script>
</body>
</html>`);
    printWindow.document.close();
  };




  return (
    <>
      <Grid container spacing={2} mb={2} position={"sticky"} top={0}>

        <Grid item xs={12} sm={2.5}>
          <TextField
            value={filters.branch}
            onChange={(e) => handleFilterChange("branch", e.target.value)}
            label="Search by Branch Name"
            size="small"
            fullWidth
            sx={{ height: "45px", marginTop: -3 }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            value={filters.billId || ""}
            onChange={(e) => handleFilterChange("billId", e.target.value)}
            label="Search by Ref No"
            size="small"
            fullWidth
            sx={{ height: "45px", marginTop: -3 }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            value={filters.freightId || ""}
            onChange={(e) => handleFilterChange("freightId", e.target.value)}
            label="Search by Freight ID"
            size="small"
            fullWidth
            sx={{ height: "45px", marginTop: -3 }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            value={filters.party}
            onChange={(e) => handleFilterChange("party", e.target.value)}
            label="Search by Party Name"
            size="small"
            fullWidth
            sx={{ height: "45px", marginTop: -3 }}
          />
        </Grid>
      </Grid>

      <InfiniteScroll
        dataLength={billings.length}
        next={fetchMoreData}
        hasMore={hasMore}
        scrollableTarget="scrollableTable"
      >
        <TableContainer
          id="scrollableTable"
          sx={{ maxHeight: "80vh", overflow: "auto" }}>
          {/* <TableContainer sx={{ overflowX: "auto", mt: 2, maxWidth: "100%" }}> */}
          {/* <div style={{ maxHeight: "75vh", overflowX: "auto" }}> */}
          <Table
            stickyHeader
            size="small"
            sx={{
              tableLayout: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "0px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead
              sx={{
                "& th": {
                  fontWeight: "bold",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                },
              }}
            >
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Ref No</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>Freight Id</TableCell>
                <TableCell>Bill Date</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Received Amount</TableCell>
                <TableCell>Balance Amount</TableCell>
                {/* Copy Three Row From Bottom For Bill */}
                <TableCell>Follow Date</TableCell>
                <TableCell>Follow Remark</TableCell>
                <TableCell>Payment Remark</TableCell>

                {/* Copy For Print Action                 */}
                <TableCell
                  align="center"
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 2,
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {billings.length > 0 ? (
                billings.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: row.is_complete
                        ? "#d0f0c0" // light green for completed
                        : index % 2 === 0
                          ? "#fafafa"
                          : "#ffffff",
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {row.branch_name === "RAIPUR"
                        ? "SRE"
                        : row.branch_name === "BILASPUR"
                          ? "JHT"
                          : "MBR"}
                      /{row.billing_id}/{getInitials(row.party_name)}
                    </TableCell>
                    <TableCell>{row.party_name}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>
                      <Tooltip
                        arrow
                        placement="top"
                        title={
                          Array.isArray(row.freights) && row.freights.length > 0 ? (
                            // 🟢 wrapper div scrollable
                            <div
                              style={{
                                maxHeight: "150px", // जरूरत के हिसाब से बदलें
                                maxWidth: "250px",  // चाहें तो width भी fix करें
                                overflowY: "auto",
                              }}
                            >
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  fontSize: "12px",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        padding: "2px 6px",
                                        fontWeight: "bold",
                                        border: "1px solid white",
                                      }}
                                    >
                                      Freight ID
                                    </th>
                                    <th
                                      style={{
                                        padding: "2px 6px",
                                        fontWeight: "bold",
                                        border: "1px solid white",
                                      }}
                                    >
                                      Truck No
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {row.freights.map((freight, i) => (
                                    <tr key={i}>
                                      <td style={{ padding: "2px 6px", border: "1px solid white" }}>
                                        {freight.freight_id}
                                      </td>
                                      <td style={{ padding: "2px 6px", border: "1px solid white" }}>
                                        {freight.truck_no}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            row.freight_id
                          )
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {Array.isArray(row.freights) && row.freights.length > 0
                            ? row.freights[0].freight_id
                            : row.freight_id}
                          {Array.isArray(row.freights) && row.freights.length > 1 ? " ..." : ""}
                        </span>
                      </Tooltip>
                    </TableCell>


                    <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    <TableCell>{row.total_amount.toFixed(2)}</TableCell>
                    <TableCell>{row.paid_amount.toFixed(2)}</TableCell>
                    <TableCell>{row.rem_amount.toFixed(2)}</TableCell>

                    <TableCell>
                      {editableRow === row.billing_id ? (
                        <TextField
                          type="date"
                          size="small"
                          value={editData.follow_date}
                          onChange={(e) =>
                            setEditData((prev) => ({ ...prev, follow_date: e.target.value }))
                          }
                          sx={{
                            width: 120, '& .MuiInputBase-root': {
                              height: 30, // 👈 reduce height here
                              fontSize: '0.75rem',
                            }, '& input': { p: 1 }
                          }} // 👈 custom size
                        />
                      ) : (
                        row.follow_date
                      )}
                    </TableCell>

                    <TableCell>
                      {editableRow === row.billing_id ? (
                        <TextField
                          size="small"
                          value={editData.remarks}
                          onChange={(e) =>
                            setEditData((prev) => ({ ...prev, remarks: e.target.value }))
                          }
                          sx={{
                            width: 120, '& .MuiInputBase-root': {
                              height: 30, // 👈 reduce height here
                              fontSize: '0.75rem',
                            }, '& input': { p: 1 }
                          }} // 👈 custom size
                        />
                      ) : (
                        row.remarks
                      )}
                    </TableCell>

                    {/* <TableCell>
                      {editableRow === row.billing_id ? (
                        <TextField
                          size="small"
                          value={editData.payment_remarks}
                          onChange={(e) =>
                            setEditData((prev) => ({ ...prev, payment_remarks: e.target.value }))
                          }
                          sx={{
                            width: 120, '& .MuiInputBase-root': {
                              height: 30, // 👈 reduce height here
                              fontSize: '0.75rem',
                            }, '& input': { p: 1 }
                          }} // 👈 custom size
                        />
                      ) : (
                        row.payment_remarks
                      )}
                    </TableCell> */}






                    <TableCell>
                      {editableRow === row.billing_id ? (
                        <TextField
                          size="small"
                          value={editData.payment_remarks}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              payment_remarks: e.target.value,
                            }))
                          }
                          sx={{
                            width: 120,
                            "& .MuiInputBase-root": {
                              height: 30,
                              fontSize: "0.75rem",
                            },
                            "& input": { p: 1 },
                          }}
                        />
                      ) : (
                        <Tooltip
                          arrow
                          placement="top"
                          title={row.payment_remarks || "No remarks"}
                        >
                          <span
                            style={{
                              maxWidth: "120px",   // सेल की चौड़ाई fix
                              display: "inline-block",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                            }}
                          >
                            {row.payment_remarks || ""}
                          </span>
                        </Tooltip>
                      )}
                    </TableCell>



                    {/* Copy This Print Button In Every Bill Section */}
                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{ position: "sticky", right: 0, backgroundColor: "#fff", zIndex: 1 }}
                    >
                      {editableRow === row.billing_id ? (
                        <IconButton
                          color="success"
                          size="small"
                          onClick={async () => {
                            try {
                              // Replace with your update API call

                              const res_data = await billUpdate(row.billing_id, {
                                follow_date: editData.follow_date || null,
                                remarks: editData.remarks,
                                payment_remarks: editData.payment_remarks,
                              });
                              setBillData(prevData =>
                                prevData.map(row =>
                                  row.billing_id === res_data.billing_id ? res_data : row
                                )
                              );
                              setEditableRow(null);
                            } catch (err) {
                              console.error("Update failed", err);
                            }
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      ) : (
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              setEditableRow(row.billing_id);
                              setEditData({
                                follow_date: row.follow_date || "",
                                remarks: row.remarks || "",
                                payment_remarks: row.payment_remarks || "",
                              });
                            }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>

                          <IconButton
                            size="small"
                            color="secondary"
                            onClick={() => {
                              switch (row.branch_name.toLowerCase()) {
                                case "raipur":
                                  handlePrintClickRaipur(row);
                                  break;
                                case "siltara":
                                  handlePrintClicksiltara(row);
                                  break;
                                case "bilaspur":
                                  handlePrintClickBilaspur(row);
                                  break;
                              }
                            }}
                          >
                            <PrintIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      )}
                    </TableCell>


                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableRow
              sx={{
                backgroundColor: "#e3f2fd",
                fontWeight: "bold",
              }}
            >
              <TableCell colSpan={6} align="right">
                Total:
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.total_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.paid_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.rem_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>

              <TableCell align="center" colSpan={4}></TableCell>
            </TableRow>
          </Table>
          {/* </div> */}
        </TableContainer>
      </InfiniteScroll>
    </>
  );
};

export default BillSummaryTable;


